export default (data, schema) => {
    return Object.keys(data).reduce((newData, key) => {
        if (
            schema.properties?.[key]?.type?.[0] === 'array' &&
            schema.properties?.[key]?.items?.type === 'integer' &&
            data[key] &&
            data[key].length
        ) {
            // Multi value list
            newData[key] = data[key].map((d) => ({
                label: d.value,
                value: d.id,
            }));
        } else if (schema.properties?.[key]?.type?.[0] === 'integer' && data?.[key]?.value) {
            // Single value list
            newData[key] = {
                label: data?.[key]?.value,
                value: data?.[key]?.id,
            };
        }

        return newData;
    }, data);
};
